import { render, staticRenderFns } from "./PrazosDeVencimentoLRFCI.vue?vue&type=template&id=08c28e9e"
import script from "./PrazosDeVencimentoLRFCI.vue?vue&type=script&lang=ts"
export * from "./PrazosDeVencimentoLRFCI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports